import { CheckBox, Table, Text } from '@factorialco/deprecated-design-system'
import isEqual from 'lodash/isEqual'

import i18n from 'modules/core/lib/i18n'

import {
  EMPLOYEE_MATCH_SELECTOR,
  FULL_NAME_COLUMN_WIDTH,
} from 'modules/payroll_bundle/pages/ResultsAndPaymentsPage/ResultsPage/constants'

interface Props {
  checkable?: boolean
  selectable?: Array<string | null>
  onSelectAll?: () => void
  selected?: Set<string>
}

const Header = ({ selected, checkable, selectable, onSelectAll }: Props) => {
  const TableCheckBox = () => {
    return (
      <CheckBox
        label={i18n.t('common.select_all')}
        checked={
          !!selected && selected.size !== 0 && isEqual([...selected].sort(), selectable?.sort())
        }
        onClick={onSelectAll}
      />
    )
  }

  return (
    <Table.Head>
      <Table.Row>
        <Table.HeadCell width={16}>
          <TableCheckBox />
        </Table.HeadCell>

        <Table.HeadCell width={FULL_NAME_COLUMN_WIDTH}>
          <Text size="200" color="grey800" weight="semibold">
            {checkable
              ? i18n.t('payroll_bundle.payroll_results.review_and_import.uploaded_name')
              : i18n.t('payroll_bundle.payroll_results.employee')}
          </Text>
        </Table.HeadCell>

        {checkable && (
          <Table.HeadCell width={EMPLOYEE_MATCH_SELECTOR}>
            {i18n.t('payroll_bundle.payroll_results.employee_match')}
          </Table.HeadCell>
        )}

        <Table.HeadCell>
          <Text size="200" color="grey800" weight="semibold">
            {i18n.t('payroll_bundle.payroll_results.review_and_import.gross_salary')}
          </Text>
        </Table.HeadCell>
        <Table.HeadCell>
          <Text size="200" color="grey800" weight="semibold">
            {i18n.t('payroll_bundle.payroll_results.review_and_import.net_salary')}
          </Text>
        </Table.HeadCell>

        <Table.HeadCell>
          <Text size="200" color="grey800" weight="semibold">
            {i18n.t('payroll_bundle.payroll_results.review_and_import.company_cost')}
          </Text>
        </Table.HeadCell>
      </Table.Row>
    </Table.Head>
  )
}

export default Header
